module.exports = __webpack_public_path__ + "static/img_slideshow_02-fdb62d02d8e8dfb3f62b927eb5e5c663.jpg";